import { Typography, Button } from 'mobily-ui-library/lib';
import { useTranslation } from "react-i18next";
import Map from '../Map/Map';
import './MapModal.scss';
import Close from '../../../assets/close.svg';

interface Props {
    handleAddress: (value: any, address: any) => void;
    rtl: boolean;
    placeholder: string;
    headingleft: string;
    labelleft: string;
    mapValue: string;
    isReciverAddressFieldVisible: boolean;
    loadCurrLoc: boolean;
    handleLocation: (value: boolean) => void;
}

function MapModal(props: Props) {
    const { handleAddress, rtl, mapValue, placeholder, headingleft, labelleft, handleLocation, isReciverAddressFieldVisible, loadCurrLoc } = props;
    const { t } = useTranslation();
    return (
        <>
            <div className='MapModal--Container'>
                <div className='MapModal--heading'>
                    <Typography className='mapModale--title'>{t('select_delivery_address')}</Typography>
                    <img src={Close} alt='close' onClick={() => handleLocation(false)} />
                </div>
                <Map
                    isReciverAddressFieldVisible={isReciverAddressFieldVisible}
                    handleAddress={handleAddress}
                    loadCurrLoc={loadCurrLoc}
                    rtl={rtl}
                    placeholder={placeholder}
                    headingleft={headingleft}
                    labelleft={labelleft}
                    mapValue={mapValue}
                />
                <div className="MapModal--Button">
                    <Button
                        primary={true}
                        className="selectBtn"
                        rtl={rtl}
                        onClick={() => handleLocation(false)}
                        variant='default'
                    >{t("select")}</Button>
                </div>
            </div>
        </>
    )
}

export default MapModal;
